import { Heading, HFlow, Text, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { LoadingIndicator } from 'components/loading'
import { useCabecalhoModalRetificacaoAtendimentoQuery } from 'graphql/hooks.generated'
import { formatDate, formatHoursMinutes } from 'util/date/formatDate'
import { CodigoIdentificadorCidadao } from 'view/cidadao/components/CodigoIdentificadorCidadao'

interface CabecalhoModalRetificacaoAtendimentoProps {
  cidadaoId: ID
  dataAtendimento: Instant
}

export function CabecalhoModalRetificacaoAtendimento(props: Readonly<CabecalhoModalRetificacaoAtendimentoProps>) {
  const { cidadaoId, dataAtendimento } = props
  const {
    data: { cidadao },
    loading,
  } = useCabecalhoModalRetificacaoAtendimentoQuery({ variables: { cidadaoId } })

  const dataAtendimentoFormatted = formatDate(dataAtendimento)
  const horarioAtendimento = formatHoursMinutes(dataAtendimento)

  return loading ? (
    <LoadingIndicator />
  ) : (
    <VFlow vSpacing={0}>
      <Heading level={3}>{(cidadao.nomeSocial ?? cidadao.nome).titleCase()}</Heading>
      <VFlow vSpacing={0}>
        <CodigoIdentificadorCidadao cpf={cidadao.cpf} cns={cidadao.cns} />
        <HFlow hSpacing={1}>
          <HLabel title='Data de nascimento'>{formatDate(cidadao.dataNascimento)}</HLabel>
          <HLabel title='Nome da mãe'>{cidadao.nomeMae?.titleCase()}</HLabel>
        </HFlow>
      </VFlow>
      <Text>
        Atendimento realizado no dia {dataAtendimentoFormatted} às {horarioAtendimento}
      </Text>
    </VFlow>
  )
}
